import permissions from "../../data/permissions"

export default {
    path: "/fleet",
    component: () => import("./../../layouts/FleetLayout.vue"),
    children: [
        {
            path: "dashboard",
            name: "FleetDashboard",
            component: () => import("./../../views/fleet/FleetDashboardView.vue")
        },
        {
            path: "drivers",
            name: "DriversList",
            component: () => import("./../../views/fleet/DriversListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.driver.index }
        },
        {
            path: "driver",
            name: "DriverCreate",
            component: () => import("./../../views/fleet/DriverCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.driver.create }
        },
        {
            path: "driver/:driverID",
            name: "DriverDisplay",
            component: () => import("./../../views/fleet/DriverDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.driver.read }
        },
        {
            path: "driver/:driverID/edit",
            name: "DriverEdit",
            component: () => import("./../../views/fleet/DriverEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.driver.update }
        },
        {
            path: "brand/:brandID/model",
            name: "ModelCreate",
            component: () => import("./../../views/fleet/ModelCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.model.create }
        },
        {
            path: "model/:modelID",
            name: "ModelDisplay",
            component: () => import("./../../views/fleet/ModelDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.model.read }
        },
        {
            path: "brand/:brandID/model/:modelID/edit",
            name: "ModelEdit",
            component: () => import("./../../views/fleet/ModelEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.model.update }
        },
        {
            path: "vehicle-usages",
            name: "VehicleUsageList",
            component: () => import("./../../views/fleet/VehicleUsageListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle_usage.index }
        },
        {
            path: "vehicle-usage",
            name: "VehicleUsageCreate",
            component: () => import("./../../views/fleet/VehicleUsageCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle_usage.create }
        },
        {
            path: "vehicle-usage/:vehicleUsageID",
            name: "VehicleUsageDisplay",
            component: () => import("./../../views/fleet/VehicleUsageDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle_usage.read }
        },
        {
            path: "vehicle-usage/:vehicleUsageID/edit",
            name: "VehicleUsageEdit",
            component: () => import("./../../views/fleet/VehicleUsageEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle_usage.update }
        },
        {
            path: "brands",
            name: "BrandList",
            component: () => import("./../../views/fleet/brand/BrandListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.brand.index }
        },
        {
            path: "brand",
            name: "BrandCreate",
            component: () => import("./../../views/fleet/brand/BrandCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.brand.create }

        },
        {
            path: "brand/:brandID",
            name: "BrandDisplay",
            component: () => import("./../../views/fleet/brand/BrandDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.brand.read }
        },
        {
            path: "brand/:brandID/edit",
            name: "BrandEdit",
            component: () => import("./../../views/fleet/brand/BrandEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.brand.update }
        },
        {
            path: "vehicles",
            name: "VehiclesList",
            component: () => import("./../../views/fleet/VehiclesListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle.index }
        },
        {
            path: "vehicle",
            name: "VehicleCreate",
            component: () => import("./../../views/fleet/VehicleCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle.create }
        },
        {
            path: "vehicle/:vehicleID/edit",
            name: "VehicleEdit",
            component: () => import("./../../views/fleet/VehicleEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle.update }
        },
        {
            path: "vehicle/:vehicleID",
            name: "VehicleDisplay",
            component: () => import("./../../views/fleet/VehicleDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.vehicle.read },
            children: [
                {
                    path: "insurance",
                    component: () => import("./../../partials/fleet/VehicleInsurancePartial.vue"),
                },
                {
                    path: "license",
                    component: () => import("./../../partials/fleet/VehicleLicensePartial.vue"),
                }
            ]
        },
        {
            path: "insurance-companies",
            name: "InsuranceCompanyList",
            component: () => import("./../../views/fleet/insurance/company/InsuranceCompanyListView.vue"),
            meta: { requiresAuth: true, authorization: permissions.insurance_company.index },
        },
        {
            path: "insurance-company",
            name: "InsuranceCompanyCreate",
            component: () => import("./../../views/fleet/insurance/company/InsuranceCompanyCreateView.vue"),
            meta: { requiresAuth: true, authorization: permissions.insurance_company.create },
        },
        {
            path: "insurance-company/:id",
            name: "InsuranceCompanyDisplay",
            component: () => import("./../../views/fleet/insurance/company/InsuranceCompanyDisplayView.vue"),
            meta: { requiresAuth: true, authorization: permissions.insurance_company.read },
        },
        {
            path: "insurance-company/:id/edit",
            name: "InsuranceCompanyEdit",
            component: () => import("./../../views/fleet/insurance/company/InsuranceCompanyEditView.vue"),
            meta: { requiresAuth: true, authorization: permissions.insurance_company.update },
        }
    ]
}